/**
 * This function handles submitting offline orders that have been stored in the OnlineQueue.
 *
 * It simply takes the OrderRequest from the OnlineTask's data and sends it to the OrderRequestSubmitter, and returns
 * the result (a promise).
 *
 * Note: Unlike other online queue tasks which go through the online queue for both online and offline submission,
 * the create order task is only added to the queue if the device is offline.
 * That means we always expect this to be happening at a later time to when the order was created and payments taken.
 *
 * @param {OnlineTask|{data: {request: OrderRequest}}} task
 * @param {OrderRequestSubmitter} orderRequestSubmitter
 *
 * @returns {Promise}
 */
const createOrderTaskHandler = (task, orderRequestSubmitter) => {
    task.data.request.reservation.onlineTaskTrigger = task.onlineTaskTrigger;
    task.data.request.order.onlineTaskTrigger = task.onlineTaskTrigger;

    return orderRequestSubmitter.submit(task.data.request);
};

module.exports = createOrderTaskHandler;
